module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAA0CAMAAADc48pLAAAAPFBMVEUAAADb6//b6//b6//b6//b6//b6//b6//b6//b6//b6//b6//b6//b6//b6//b6//b6//b6//b6//b6/8awAzlAAAAE3RSTlMA7M7hgygSLxenoozHrtY2dh6VvCWg/AAAAJVJREFUOMvNkM0SgzAIBmkI2NbEn/L+79oZDnKh2EnU8bsuu2aEn3uODNE4SeKIFxEpHPmiFwHXJQq4LrvvN1459l+uP5kPLT6GvN8vf7//3eQn80Pe79cmf+r7/op9Pj02/gFvs2xbwN1giQx+Y/diuPpibG0Q3q6Rz2vQEY2r//qy08AZwgaSB62Bq0OsoX50UZV/AX9yIohF0a+oAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images/return.png
// module id = ahJr
// module chunks = 1